import { types } from './types';
import { instance } from '../utils';
import { triggerNotification } from '../../components';

export const triggerLoading = payload => dispatch => {
    dispatch({ type: 'TRIGGER_LOADING', payload });
  };

export const getAppConfig = ({callback}) => dispatch => {
  const url = `/api/config/getAppConfig`;
  const headers = {
    "Content-Type": "application/json",
  }
  dispatch({ type: types.GET_APP_CONFIG.START });
  instance
  .get(url, { headers })
  .then(response => {
    console.debug("in response we have ",response.data);
    dispatch({ 
      type: types.GET_APP_CONFIG.SUCCESS, 
      payload: response.data 
    });
  })
  .catch(error => {
    dispatch({ type: types.GET_APP_CONFIG.ERROR,payload: error?.response?.data?.error });
  })
  .finally(() => callback());
};

export const updateAppConfig = ({payload, callback}) => dispatch => {
  const url = `/api/config/updateAppConfig`;
  const headers = {
    "Content-Type": "application/json",
  }
  dispatch({ type: types.UPDATE_APP_CONFIG.START });
  instance
  .post(url, {...payload}, { headers })
  .then(response => {
    console.debug("in response we have ",response.data);
    dispatch({ 
      type: types.UPDATE_APP_CONFIG.SUCCESS, 
      payload: response.data 
    });
    callback(true)
  })
  .catch(error => {
    console.log("updateAppConfig",error?.response?.data?.error)

    dispatch({ type: types.UPDATE_APP_CONFIG.ERROR,payload: error?.response?.data?.error });
    callback(false)
  });
  // dispatch({ type: 'GET_APP_CONFIG', payload });
};

export const restoreToFactorySettings = ({callback}) => dispatch => {
  const url = `/api/config/restoreAppConfig`;
  const headers = {
    "Content-Type": "application/json",
  }
  dispatch({ type: types.RESTORE_APP_CONFIG.START });
  instance
  .get(url, { headers })
  .then(response => {
    console.debug("in response we have ",response.data);
    dispatch({ 
      type: types.RESTORE_APP_CONFIG.SUCCESS, 
      payload: response.data 
    });
    callback(true)
  })
  .catch(error => {
    console.log("restoreToFactorySettings",error?.response?.data?.error)
    dispatch({ type: types.RESTORE_APP_CONFIG.ERROR,payload: error?.response?.data?.error });
    callback(false)
  });
}

export const generateObligationIds = () => dispatch => {
  const url = `/api/config/generateIDs`;
  const headers = {
    "Content-Type": "application/json",
  }
  dispatch({ type: types.GENERATE_IDS.START });
  instance
  .get(url, { headers })
  .then(response => {
    console.debug("in response we have ",response.data);
    dispatch({ 
      type: types.GENERATE_IDS.SUCCESS, 
      payload: response.data 
    });
    triggerNotification({});
  })
  .catch(error => {
    console.log("generateObligationIds",error?.response?.data?.error)
    dispatch({ type: types.GENERATE_IDS.ERROR, payload: error?.response?.data?.error });
    triggerNotification({
      message: "Error",
      description: error?.response?.data?.error,
      status: "Error"
    });
  });
}

export const fixObligationIds = (type) => dispatch => {
  const url = `/api/config/${type}/fixIDs`;
  const headers = {
    "Content-Type": "application/json",
  }
  dispatch({ type: types.FIX_IDS.START });
  instance
  .get(url, { headers })
  .then(response => {
    console.debug("in response we have ",response.data);
    dispatch({ 
      type: types.FIX_IDS.SUCCESS, 
      payload: response.data 
    });
    triggerNotification({});
  })
  .catch(error => {
    console.log("fixObligationIds",error?.response?.data?.error)
    dispatch({ type: types.FIX_IDS.ERROR, payload: error?.response?.data?.error });
    triggerNotification({
      message: "Error",
      description: error?.response?.data?.error,
      status: "Error"
    });
  });
}

export const clearConfigError = () => dispatch => {
  dispatch({ type: types.CLEAR_CONFIG_ERROR.SUCCESS});
}

export const editObligationModal = payload => dispatch => {
  dispatch({ type: 'EDIT_OBLIGATION_MODAL', payload });
};

export const setFilteredUsers = payload => dispatch => {
  // console.debug({payload})
  dispatch({ type: 'SET_FILTERED_USERS', payload});
}

export const setOblFilterField = payload => dispatch => {
  // console.debug({payload})
  dispatch({ type: 'SET_OBL_FILTER_FIELD', payload});
}

export const setVariable = payload => dispatch => {
  // console.debug({payload})
  dispatch({ type: types.SET_VARIABLE.SUCCESS, payload});
}

// old one
// export const sendEmail = (targetEmail, loginLink, user) => dispatch => {
//   const url = `/api/user/sendemail`;
//   const headers = {
//     "Content-Type": "application/json",
//     'Authorization': `Bearer ${user.token}`
//   }
//   const body = {
//     targetEmail,
//     fullName: user.firstName + ' ' + user.lastName,
//     loginLink,
//   }
//   dispatch({ type: types.SEND_EMAIL.START });
//   instance
//   .post(url, body, { headers })
//   .then(response => {
//     dispatch({ type: types.SEND_EMAIL.SUCCESS });
//   })
//   .catch(error => {
//     dispatch({ type: types.SEND_EMAIL.ERROR, payload: error.message });
//   });
// }